(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-gift-form]');
    const button = root.querySelector('[data-gift-add]');
    const status = root.querySelector('[data-gift-status]');
    const variants = {pair: JSON.parse(root.querySelector('[data-gift-pair]').textContent), og: JSON.parse(root.querySelector('[data-gift-og]').textContent), sd: JSON.parse(root.querySelector('[data-gift-sd]').textContent)};
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: root.dataset.currency});
    let selection;
    const requested = new URLSearchParams(window.location.search);
    const requestedPair = variants.pair.find(v => String(v.id) === requested.get('variant'));
    if (requestedPair) {
      form.elements.nt_paid_color.value = requestedPair.option1;
      const requestedCount = requestedPair.option2.split(' ')[0];
      const pairInput = Array.from(form.elements.nt_offer).find(input => input.value === `pair-${requestedCount}`);
      if (pairInput) pairInput.checked = true;
    }
    const requestedOffer = Array.from(form.elements.nt_offer).find(input => input.value === requested.get('offer'));
    if (requestedOffer) requestedOffer.checked = true;
    function update() {
      const [design, pack] = form.elements.nt_offer.value.split('-');
      const isPair = design === 'pair';
      const paid = variants[design].find(v => v.option1 === form.elements.nt_paid_color.value && (isPair ? v.option2.split(' ')[0] === pack : v.option2 === pack));
      const gift = isPair ? null : variants[design === 'og' ? 'sd' : 'og'].find(v => v.option1 === form.elements.nt_free_color.value && v.option2 === '1');
      const quantity = pack === '10' ? 2 : 1;
      selection = {paid, gift, quantity};
      form.elements['items[0][id]'].value = paid?.id || '';
      form.elements['items[1][id]'].value = gift?.id || '';
      form.elements['items[1][quantity]'].value = quantity;
      form.elements['items[1][id]'].disabled = isPair;
      form.elements['items[1][quantity]'].disabled = isPair;
      root.querySelector('[data-gift-color]').hidden = isPair;
      form.elements.nt_free_color.disabled = isPair;
      root.querySelector('[data-offer-note]').textContent = isPair ? (pack === '1' ? root.dataset.pairNote : root.dataset.mixedNote.replaceAll('__COUNT__', pack).replace('__TOTAL__', String(Number(pack) * 2))) : root.dataset.giftNote;
      button.disabled = !(paid?.available && (isPair || gift?.available));
      const label = isPair ? (pack === '1' ? root.dataset.addPair : root.dataset.addMixed.replace('__COUNT__', pack)) : pack === '10' ? root.dataset.addTwelve : root.dataset.addSix;
      button.textContent = button.disabled ? root.dataset.unavailable : `${label} · ${money.format(paid.price / 100)}`;
      status.textContent = '';
    }
    form.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = root.dataset.working;
      try {
        const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:selection.gift ? [{id:selection.paid.id,quantity:1},{id:selection.gift.id,quantity:selection.quantity}] : [{id:selection.paid.id,quantity:1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        window.location.assign(form.elements.return_to.value);
      } catch (error) {
        update();
        status.textContent = error.message || root.dataset.error;
      }
    });
    update();
  }
  document.querySelectorAll('[data-cross-gift]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cross-gift]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trio-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-trio-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-trio-slide]').forEach(slide => {
          slide.hidden = slide.dataset.trioSlide !== button.dataset.trioThumb;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        root.querySelectorAll('[data-trio-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  }
  document.querySelectorAll('[data-trio-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-trio-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
